import React, { useCallback } from 'react';
import { Menu } from '@ui/menus/Menu';
import { Icon } from '@ui/Icon';

type ActionContextMenuProps = {
  anchor: HTMLElement | null;
  onClose: () => void;
  onRename: () => void;
  onDelete: () => void;
};

/**
 * Context menu for an {@link Action} row.
 * Pass the kebab button element as {@link anchor} and clear it in {@link onClose}.
 */
export const ActionContextMenu: React.FC<ActionContextMenuProps> = ({
  anchor,
  onClose,
  onRename,
  onDelete,
}) => {
  const handleRename = useCallback(() => {
    onClose();
    onRename();
  }, [onClose, onRename]);

  const handleDelete = useCallback(() => {
    onClose();
    onDelete();
  }, [onClose, onDelete]);

  return (
    <Menu open={!!anchor} anchorEl={anchor} onClose={onClose}>
      <Menu.Item
        icon={<Icon category="mui" icon="DriveFileRenameOutline" />}
        onClick={handleRename}
      >
        Rename
      </Menu.Item>
      <Menu.Item
        icon={<Icon category="mui" icon="DeleteForever" />}
        onClick={handleDelete}
      >
        Delete
      </Menu.Item>
    </Menu>
  );
};
